import MarketingImage from '@/components/landing/MarketingImage';
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const dataRepRepresentation = '/images/marketing/landing-datarep-representation.webp';
import styles from './FaqSection.module.css';

const faqs = [
  {
    question: 'Is my client data secure?',
    answer:
      "CalorieScience is EU and UK GDPR compliant. Your data and your clients' data are encrypted, access-controlled, and stored within compliant infrastructure."
  },
  {
    question: 'How much time does it take to get started?',
    answer:
      'Most practitioners can set up their practice, invite clients, and begin using intake workflows within a single session.'
  },
  // {
  //   question: 'What happens after I book a demo?',
  //   answer:
  //     'Our team walks you through the platform, learns how your practice works, and recommends the setup that fits your workflows.'
  // },
  {
    question: 'Will my clients actually use the app?',
    answer:
      'The client app keeps plans, progress, questionnaires, communication, and adherence in one place.'
  },
  {
    question: 'Can I customise questionnaires and plans?',
    answer:
      'Yes. You can customise questionnaires, templates, and plan structures to match your practice style and client needs.'
  }
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2>Frequently Asked Questions</h2>
        <div className={styles.list}>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <article className={styles.item} key={faq.question}>
                <button
                  type="button"
                  className={styles.question}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                >
                  <span>{faq.question}</span>
                  <span className={styles.icon} aria-hidden="true">
                    {isOpen ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </button>
                {isOpen ? (
                  <div className={styles.answerContent}>
                    <p>{faq.answer}</p>
                    {index === 0 ? (
                      <MarketingImage
                        src={dataRepRepresentation}
                        alt="DataRep representation in Switzerland, the EU, and the UK"
                        className={styles.dataRepImage}
                      />
                    ) : null}
                  </div>
                ) : null}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
